export const INITIAL_FETCH_SUCCESS = 'ACCEPT_ALL_PRICE_CHANGES_TOGGLE::INITIAL_FETCH_SUCCESS';
export const SETTINGS_UPDATE_START = 'ACCEPT_ALL_PRICE_CHANGES_TOGGLE::SETTINGS_UPDATE_START';
export const SETTINGS_UPDATE_SUCCESS = 'ACCEPT_ALL_PRICE_CHANGES_TOGGLE::SETTINGS_UPDATE_SUCCESS';
export const SETTINGS_UPDATE_ERROR = 'ACCEPT_ALL_PRICE_CHANGES_TOGGLE::SETTINGS_UPDATE_ERROR';
export const BET_PLACED_UPDATE = 'ACCEPT_ALL_PRICE_CHANGES_TOGGLE::BET_PLACED_UPDATE';

export const initialFetchSuccess = (value) => ({
  type: INITIAL_FETCH_SUCCESS,
  value,
});

export const settingsUpdateStart = () => ({
  type: SETTINGS_UPDATE_START,
});

export const settingsUpdateSuccess = (newValue) => ({
  type: SETTINGS_UPDATE_SUCCESS,
  newValue,
});

export const betPlacedUpdate = () => ({
  type: BET_PLACED_UPDATE,
});

export const settingsUpdateError = () => ({
  type: SETTINGS_UPDATE_ERROR,
});
